import { FadeUp } from "@/components/Reveal";
import { IMAGES } from "@/data/content";

const PILLARS = [
  {
    n: "01",
    title: "Curated Dining",
    body:
      "A Mediterranean-leaning, hearth-driven menu catered by Aba — the West Loop favorite — and served at the table by a private waiter. Smoky bread, kebabs from the grill, sides built to be passed.",
    image: IMAGES.dining,
    label: "Cuisine",
  },
  {
    n: "02",
    title: "Signature Cocktails",
    body:
      "A private bartender pouring two signature cocktails plus a full wine, beer, and spirits program. Spirit-free options always present.",
    image: IMAGES.cocktail,
    label: "Bar",
  },
  {
    n: "03",
    title: "Vinyl Soundtrack",
    body:
      "Every guest chooses a record. Bring a favorite if you have one — I'll keep a backup library on hand. The night plays only what the room asks for, start to finish, side A to side B.",
    image: IMAGES.vinyl,
    label: "Sound",
  },
  {
    n: "04",
    title: "Intimate Gathering",
    body:
      "Eight seats. One shared table. A private waiter who learns your name by the second course. Strangers become regulars somewhere around the third pour.",
    image: null,
    label: "Room",
  },
];

export const Experience = () => {
  return (
    <section
      id="experience"
      data-testid="experience-section"
      className="section-pad relative bg-[#0c0c0c]"
    >
      <div className="max-w-[1300px] mx-auto">
        <FadeUp className="max-w-[700px]">
          <div className="eyebrow-line">The Experience</div>
          <h2
            className="font-serif-display text-[#FDFBF7] mt-6 leading-[1.05]"
            style={{ fontSize: "clamp(36px, 5vw, 56px)" }}
          >
            Four pillars,<br />
            <span className="italic text-[#D4AF37]">one continuous evening.</span>
          </h2>
        </FadeUp>

        <div className="mt-20 grid md:grid-cols-12 gap-x-8 gap-y-16 md:gap-y-24">
          {PILLARS.map((p, idx) => {
            // Asymmetric grid placement
            const placements = [
              "md:col-span-7 md:col-start-1",
              "md:col-span-5 md:col-start-8 md:mt-24",
              "md:col-span-6 md:col-start-2",
              "md:col-span-5 md:col-start-8",
            ];
            return (
              <FadeUp
                key={p.n}
                delay={idx * 0.1}
                className={placements[idx]}
              >
                <article data-testid={`pillar-${p.n}`} className="group">
                  {p.image && (
                    <div className="relative overflow-hidden mb-8 aspect-[4/3] md:aspect-[5/4]">
                      <img
                        src={p.image}
                        alt={p.title}
                        loading="lazy"
                        className="absolute inset-0 w-full h-full object-cover transition-transform duration-[1200ms] ease-out group-hover:scale-105"
                      />
                      <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent" />
                      <span className="absolute top-4 left-4 overline">{p.label}</span>
                    </div>
                  )}
                  <div className="flex items-baseline gap-6">
                    <span className="font-serif-display text-[#D4AF37] text-3xl">{p.n}</span>
                    <h3 className="font-serif-display text-[#FDFBF7] text-3xl md:text-4xl">
                      {p.title}
                    </h3>
                  </div>
                  <p className="mt-5 text-[#A3A3A3] leading-[1.75] max-w-[48ch] text-base">
                    {p.body}
                  </p>
                </article>
              </FadeUp>
            );
          })}
        </div>
      </div>
    </section>
  );
};
